export default {
    version: JSON.stringify(require('../../package.json').version).replace(/"/g, ''),
    language: 0,
    changed: 0,
    changedRegister: 0,

    rating: {
        value: 0,
        reviews: 0
    },



    deferredPrompt: null,
    wait: {
        name: '',
        state: false
    },
    defaults: {},
    // Пользователь
    user: {
        registered: false,
        admin: false,
        password: '',
        password2: '',
        usesecret: 1,
        recoveryphone: ''
    },
    // Сообщения
    messages: [],
    // Справочники
    registers: {
        // Организации
        orgs: {
            list: [],
            current: {}
        },
        // Подразделения
        groups: {
            list: [],
            current: {}
        },
        // Сотрудники
        workers: {
            list: [],
            current: {}
        }
    },
    // Перечисления
    enums: {
        sums_primary: [],
        sums_secondary: [],
        deductions: []
    },
    // Реестр зарплаты
    salary: {
        month: 0,
        year: new Date().getFullYear(),
        data: {
            list: [],
            current: {}
        }
    },
    // Калькулятор
    calc: {},
    // Отчеты
    reports: {
        form200: {
            quarter: 0,
            year: 2020,
            data: {},
            form_200_00: {},
            form_200_01: {},
            form_200_02: {},
            form_200_03: {},
            form_200_04: {},
            form_200_05: {}
        }
    }
}
